import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TaskListing, TaskAddEdit } from './Pages';

export const TaskRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={TaskListing} />
        <Route exact path={`${match.path}/AddEdit`} component={TaskAddEdit} />
    </Fragment>
)